import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import {
  Hospital,
  Person,
  Telephone,
  Envelope,
  Printer,
  Globe,
  GeoAlt,
  PinMap,
  Building,
  Map,
  Signpost2,
  GeoFill,
} from "react-bootstrap-icons";
//Context import
import AuthContext from "../../../components/shared/Context";

const MyTCProfileViewChild = () => {
  const { loggedInUserDetails } = useContext(AuthContext);
  const [tcDetail, setTCDetail] = useState();

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");
      let urlLink = `${process.env.REACT_APP_API_URL}/tc/${loggedInUserDetails.tc_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      axios(config)
        .then(function (response) {
          const tcData = response.data.treatment_center;
          setTCDetail(tcData);
        })
        .catch(function (error) {
          console.error("Error fetching TC details:", error);
        });
    };

    getDataFromServer();
  }, [loggedInUserDetails.tc_id]);

  return (
    <div className="container py-4">
      <div className="card shadow-sm border-0 rounded-3">
        <div className="card-header bg-primary bg-gradient text-white py-3">
          <div className="d-flex align-items-center">
            <Hospital className="me-2" size={24} />
            <h4 className="mb-0 text-white">Treatment Center Details</h4>
          </div>
        </div>
        <div className="card-body p-4">
          {tcDetail && (
            <div className="row g-4">
              <div className="col-md-6">
                <div className="h-100 p-4 bg-light rounded-3">
                  <h5 className="text-primary mb-4 d-flex align-items-center">
                    <Person className="me-2" size={20} />
                    Basic Information
                  </h5>
                  <div className="list-group list-group-flush">
                    <div className="list-group-item bg-transparent px-0">
                      <strong>TC Name:</strong>
                      <p className="mb-0 text-muted">
                        {tcDetail.tcenters.name_tc}
                      </p>
                    </div>
                    <div className="list-group-item bg-transparent px-0">
                      <strong>TC ID:</strong>
                      <p className="mb-0 text-muted">
                        {tcDetail.tcenters.treatment_center_id}
                      </p>
                    </div>
                    <div className="list-group-item bg-transparent px-0">
                      <strong>HDCC No:</strong>
                      <p className="mb-0 text-muted">
                        {tcDetail.tcenters.hdcc_no}
                      </p>
                    </div>
                    <div className="list-group-item bg-transparent px-0">
                      <strong>Institution:</strong>
                      <p className="mb-0 text-muted">
                        {tcDetail.tcenters.institution}
                      </p>
                    </div>
                    <div className="list-group-item bg-transparent px-0">
                      <strong>TC Type:</strong>
                      <p className="mb-0 text-muted">
                        {tcDetail.tcenters.tc_type}
                      </p>
                    </div>
                    <div className="list-group-item bg-transparent px-0">
                      <strong>Nodal Status:</strong>
                      <p className="mb-0">
                        <span
                          className={`badge ${
                            tcDetail.tcenters.nodal_status
                              ? "bg-success"
                              : "bg-secondary"
                          }`}
                        >
                          {tcDetail.tcenters.nodal_status ? "Yes" : "No"}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="h-100 p-4 bg-light rounded-3">
                  <h5 className="text-primary mb-4 d-flex align-items-center">
                    <Telephone className="me-2" size={20} />
                    Contact Information
                  </h5>
                  <div className="list-group list-group-flush">
                    <div className="list-group-item bg-transparent px-0">
                      <strong>
                        <Envelope className="me-2" />
                        Primary Email:
                      </strong>
                      <p className="mb-0 text-muted">
                        {tcDetail.tcenters.primary_email}
                      </p>
                    </div>
                    {tcDetail.tcenters.secondary_email && (
                      <div className="list-group-item bg-transparent px-0">
                        <strong>
                          <Envelope className="me-2" />
                          Secondary Email:
                        </strong>
                        <p className="mb-0 text-muted">
                          {tcDetail.tcenters.secondary_email}
                        </p>
                      </div>
                    )}
                    <div className="list-group-item bg-transparent px-0">
                      <strong>
                        <Telephone className="me-2" />
                        Phone:
                      </strong>
                      <p className="mb-0 text-muted">
                        {tcDetail.tcenters.phone}
                      </p>
                    </div>
                    {tcDetail.tcenters.fax && (
                      <div className="list-group-item bg-transparent px-0">
                        <strong>
                          <Printer className="me-2" />
                          Fax:
                        </strong>
                        <p className="mb-0 text-muted">
                          {tcDetail.tcenters.fax}
                        </p>
                      </div>
                    )}
                    {tcDetail.tcenters.website && (
                      <div className="list-group-item bg-transparent px-0">
                        <strong>
                          <Globe className="me-2" />
                          Website:
                        </strong>
                        <p className="mb-0">
                          <a
                            href={tcDetail.tcenters.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary"
                          >
                            {tcDetail.tcenters.website}
                          </a>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="p-4 bg-light rounded-3">
                  <h5 className="text-primary mb-4 d-flex align-items-center">
                    <GeoAlt className="me-2" size={20} />
                    Address Details
                  </h5>
                  <div className="row g-4">
                    <div className="col-lg-6">
                      <div className="card h-100 border-0 bg-white shadow-sm">
                        <div className="card-body">
                          <h6 className="card-subtitle mb-3 text-primary d-flex align-items-center">
                            <Map className="me-2" size={16} />
                            Location Details
                          </h6>
                          <div className="mb-3">
                            <div className="d-flex align-items-center mb-2">
                              <Building className="text-muted me-2" size={16} />
                              <strong>Complete Address</strong>
                            </div>
                            <p className="mb-0 ms-4 text-muted">
                              {tcDetail.tcenters.address_line1}
                              {tcDetail.tcenters.address_line2 && (
                                <>
                                  <br />
                                  {tcDetail.tcenters.address_line2}
                                </>
                              )}
                            </p>
                          </div>
                          {tcDetail.tcenters.landmark && (
                            <div className="mb-3">
                              <div className="d-flex align-items-center mb-2">
                                <Signpost2
                                  className="text-muted me-2"
                                  size={16}
                                />
                                <strong>Landmark</strong>
                              </div>
                              <p className="mb-0 ms-4 text-muted">
                                {tcDetail.tcenters.landmark}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="card h-100 border-0 bg-white shadow-sm">
                        <div className="card-body">
                          <h6 className="card-subtitle mb-3 text-primary d-flex align-items-center">
                            <GeoFill className="me-2" size={16} />
                            Region Information
                          </h6>
                          <div className="row g-3">
                            <div className="col-sm-6">
                              <div className="d-flex align-items-center mb-2">
                                <GeoAlt className="text-muted me-2" size={16} />
                                <strong>District</strong>
                              </div>
                              <p className="mb-0 ms-4 text-muted">
                                {tcDetail.tcenters.district}
                              </p>
                            </div>
                            <div className="col-sm-6">
                              <div className="d-flex align-items-center mb-2">
                                <Map className="text-muted me-2" size={16} />
                                <strong>State</strong>
                              </div>
                              <p className="mb-0 ms-4 text-muted">
                                {tcDetail.tcenters.state}
                              </p>
                            </div>
                            <div className="col-sm-6">
                              <div className="d-flex align-items-center mb-2">
                                <Globe className="text-muted me-2" size={16} />
                                <strong>Country</strong>
                              </div>
                              <p className="mb-0 ms-4 text-muted">
                                {tcDetail.tcenters.country}
                              </p>
                            </div>
                            <div className="col-sm-6">
                              <div className="d-flex align-items-center mb-2">
                                <PinMap className="text-muted me-2" size={16} />
                                <strong>Pincode</strong>
                              </div>
                              <p className="mb-0 ms-4 text-muted">
                                {tcDetail.tcenters.pincode}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyTCProfileViewChild;
